var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pad-home"},[_c('HeaderBar',{attrs:{"title":"联系客服","showLeft":true}}),_c('div',{staticClass:"phoneImg1"}),_c('div',{staticClass:"phoneImg2"}),_c('div',{staticClass:"phoneImg3"}),_c('div',{staticClass:"phoneImg4"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }